import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table-data-root" }
const _hoisted_2 = { class: "table-card-shell tableCornerRadiusForAudit mb-16 bg-white" }
const _hoisted_3 = { class: "table-card-inner" }
const _hoisted_4 = { class: "table-container table-container-fit" }
const _hoisted_5 = { class: "table-header-wrap" }
const _hoisted_6 = { class: "table-header-row" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex table-header-label-wrap" }
const _hoisted_9 = ["onMousemove"]
const _hoisted_10 = ["onMousedown"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "table-body-scroll" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-red-500" }
const _hoisted_19 = {
  key: 0,
  class: "error-text"
}
const _hoisted_20 = {
  key: 1,
  class: "error-text"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "text-red-500" }
const _hoisted_23 = {
  key: 0,
  class: "error-text"
}
const _hoisted_24 = {
  key: 1,
  class: "error-text"
}
const _hoisted_25 = { key: 2 }
const _hoisted_26 = ["onMousemove"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = ["onMousemove"]
const _hoisted_30 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", {
              class: "table-fit-card table-header-table",
              style: _normalizeStyle(_ctx.tableResizeStyle)
            }, [
              _createElementVNode("colgroup", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: 'h-'+columnName,
                    style: _normalizeStyle(_ctx.columnStyle(columnName))
                  }, null, 4))
                }), 128))
              ]),
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                    return (_openBlock(), _createElementBlock("th", {
                      scope: "col",
                      key: columnName,
                      class: _normalizeClass(["bg-white capitalize resizable-th", _ctx.getColumnHeadWidth(columnName)]),
                      style: _normalizeStyle(_ctx.columnStyle(columnName)),
                      onClick: ($event: any) => (_ctx.onHeaderClick(columnName)),
                      onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doFalse()))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "cursor-pointer table-header-label",
                          onMousemove: ($event: any) => (_ctx.headerToolTip(columnName, $event))
                        }, _toDisplayString(_ctx.getColumnLabel(columnName)), 41, _hoisted_9),
                        (_ctx.getColumnLabel(columnName) != '')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["sort cursor-pointer", _ctx.className == columnName ? _ctx.classSort : 'opacity-50'])
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", {
                        class: "column-resize-handle",
                        onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, columnName)), ["stop","prevent"])
                      }, null, 40, _hoisted_10),
                      (_ctx.pop == true && _ctx.tipColumn == columnName && _ctx.tipIndex == 'header')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_tool_tip, {
                              columnName: columnName,
                              tipText: _ctx.tipText,
                              styling: _ctx.styling
                            }, null, 8, ["columnName", "tipText", "styling"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 46, _hoisted_7))
                  }), 128))
                ])
              ])
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("table", {
              class: "table-fit-card",
              style: _normalizeStyle(_ctx.tableResizeStyle)
            }, [
              _createElementVNode("colgroup", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: 'b-'+columnName,
                    style: _normalizeStyle(_ctx.columnStyle(columnName))
                  }, null, 4))
                }), 128))
              ]),
              (_ctx.sortedData.length == 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                    _createElementVNode("tr", _hoisted_14, [
                      _createElementVNode("td", {
                        class: "relative h-10",
                        colspan: _ctx.columnNames.size
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "flex justify-center" }, [
                          _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                        ], -1)
                      ]), 8, _hoisted_15)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row,
                        class: "cursor-pointer rowHeight"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: columnName,
                            onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doFalse())),
                            class: _normalizeClass(["cursor-pointer relative", _ctx.getColumnHeadWidth(columnName)]),
                            style: _normalizeStyle(_ctx.columnStyle(columnName))
                          }, [
                            (columnName == 'auditee')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: row['auditee'],
                                    "onUpdate:modelValue": ($event: any) => ((row['auditee']) = $event),
                                    suggestions: _ctx.auditeeOptions,
                                    optionLabel: "label",
                                    placeholder: "Auditee",
                                    class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                    'p-invalid': _ctx.validationErrors[index]?.auditee || _ctx.validationErrors[index]?.sameAuditorAuditee,
                                    'has-options': _ctx.auditeeOptions && _ctx.auditeeOptions.length > 0,
                                    'no-options': !_ctx.auditeeOptions.length && _ctx.searchValue !== '',
                                }]),
                                    onComplete: _ctx.asyncFind,
                                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkAfterRequired('check')))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions", "class", "onComplete"]),
                                  _createElementVNode("div", _hoisted_18, [
                                    (_ctx.validationErrors[index]?.auditee)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Required"))
                                      : _createCommentVNode("", true),
                                    (_ctx.validationErrors[index]?.sameAuditorAuditee)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Auditee and Auditor cannot be the same"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (columnName == 'auditor')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: row['auditor'],
                                      "onUpdate:modelValue": ($event: any) => ((row['auditor']) = $event),
                                      suggestions: _ctx.auditorOptions,
                                      optionLabel: "label",
                                      placeholder: "Auditor",
                                      class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                    'p-invalid': _ctx.validationErrors[index]?.auditor || _ctx.validationErrors[index]?.sameAuditorAuditee,
                                    'has-options': _ctx.auditorOptions && _ctx.auditorOptions.length > 0,
                                    'no-options': !_ctx.auditorOptions.length &&  _ctx.searchValue !== '',
                                }]),
                                      onComplete: _ctx.asyncFind1,
                                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkAfterRequired('check')))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions", "class", "onComplete"]),
                                    _createElementVNode("div", _hoisted_22, [
                                      (_ctx.validationErrors[index]?.auditor)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Required"))
                                        : _createCommentVNode("", true),
                                      (_ctx.validationErrors[index]?.sameAuditorAuditee)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Auditee and Auditor cannot be the same"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : (columnName=='entity')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createElementVNode("div", {
                                        class: "table-ellipsis",
                                        onMousemove: ($event: any) => (_ctx.toolTip(columnName, $event, index, row, 'text'))
                                      }, _toDisplayString(row[columnName]), 41, _hoisted_26),
                                      (_ctx.pop == true && _ctx.tipColumn == columnName && _ctx.tipIndex == index)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            _createVNode(_component_tool_tip, {
                                              columnName: columnName,
                                              tipText: _ctx.tipText,
                                              styling: _ctx.styling
                                            }, null, 8, ["columnName", "tipText", "styling"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (columnName=='team')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        _createElementVNode("div", {
                                          class: "table-ellipsis",
                                          onMousemove: ($event: any) => (_ctx.toolTip(columnName, $event, index, row, 'text'))
                                        }, _toDisplayString(row[columnName]), 41, _hoisted_29),
                                        (_ctx.pop == true && _ctx.tipColumn == columnName && _ctx.tipIndex == index)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                              _createVNode(_component_tool_tip, {
                                                columnName: columnName,
                                                tipText: _ctx.tipText,
                                                styling: _ctx.styling
                                              }, null, 8, ["columnName", "tipText", "styling"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                          ], 38))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
            ], 4)
          ])
        ]),
        _createVNode(_component_pagination, {
          dynamicPagination: _ctx.dynamicPagination,
          onCurrentPageUpdate: _ctx.paginationUpdations,
          entityId: _ctx.entityId,
          sortedData: _ctx.sortedData
        }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "entityId", "sortedData"])
      ])
    ])
  ]))
}